export const footerLinks = {
  groups: [
    {
      title: "TravelOne.pl",
      id: 0,
      items: [
        {
          link: "https://www.travelone.pl/onas.html",
          title: "O nas",
          newTab: false
        },
        {
          link: "https://www.travelone.pl/kontakt.html",
          title: "Kontakt",
          newTab: false
        },
        {
          link:
            "https://www.travelone.pl/warunki/regulamin_korzystania_z_serwisu_t1.pdf",
          title: "Regulamin",
          newTab: false
        },
        {
          link: "https://www.travelone.pl/warunki/polityka_prywatnosci_t1.pdf",
          title: "Polityka prywatności",
          newTab: false
        },
        {
          link: "/portale-turystyczne.xml",
          title: "Portale turystyczne",
          newTab: false
        },
        {
          link: "/rodzaj-oferty.xml",
          title: "Kategorie ofert",
          newTab: false
        },
        {
          link: "/mapa-serwisu.xml",
          title: "Mapa serwisu",
          newTab: false
        }
      ]
    },
    {
      title: "Popularne kierunki",
      id: 1,
      items: [
        {
          link: "https://www.turcja.com.pl/",
          title: "Turcja",
          newTab: true
        },
        {
          link: "https://www.hiszpania.com.pl/",
          title: "Hiszpania",
          newTab: true
        },
        {
          link: "https://www.wyspykanaryjskie.pl/",
          title: "Wyspy Kanaryjskie",
          newTab: true
        },
        {
          link: "https://www.grecja.com.pl/",
          title: "Grecja",
          newTab: true
        },
        {
          link: "https://www.bulgaria.pl/",
          title: "Bułgaria",
          newTab: true
        },
        {
          link: "https://www.chorwacja.pl/",
          title: "Chorwacja",
          newTab: true
        },
        {
          link: "https://www.tunezja.com.pl/",
          title: "Tunezja",
          newTab: true
        },
        {
          link: "https://www.egipt.info.pl/",
          title: "Egipt",
          newTab: true
        }
      ]
    },
    {
      title: "Serwisy tematyczne",
      id: 2,
      items: [
        {
          link: "http://lastminute.travelone.pl/",
          title: "Last Minute",
          newTab: true
        },
        {
          link: "http://firstminute.travelone.pl/",
          title: "First Minute",
          newTab: true
        },
        {
          link: "http://www.allinclusive.travelone.pl/",
          title: "All Inclusive",
          newTab: true
        },
        {
          link: "http://egzotyka.travelone.pl/",
          title: "Egzotyka",
          newTab: true
        },
        {
          link: "http://feriezimowe.travelone.pl/",
          title: "Ferie zimowe",
          newTab: true
        },
        {
          link: "http://weekendmajowy.travelone.pl/",
          title: "Weekend majowy",
          newTab: true
        },
        {
          link: "http://promocje.travelone.pl/",
          title: "Promocje",
          newTab: true
        },
        {
          link: "http://sylwester.travelone.pl/",
          title: "Sylwester",
          newTab: true
        },
      ]
    },
    {
      title: "Przydatne linki",
      id: 3,
      items: [
        {
          link: "https://dsc.travelplanet.pl/mkt-tp/hp-documents/pozasadowe-rozwiazywanie-sporow-konsumenckich.pdf",
          title: "Informacje o ADR",
          newTab: true
        },
        {
          link: "https://dsc.travelplanet.pl/mkt-tp/hp-documents/formularz-do-zglaszania-nielegalnych-tresci.pdf",
          title: "Zgłoś nielegalną treść",
          newTab: true
        }
      ]
    }
  ]
};
